import { watchAll } from "./sagas";
import { watchMisc } from "./sagas/miscSagas";
import root from "./rootReducer";
import createSagaMiddleware from "redux-saga";
import { configureStore } from "@reduxjs/toolkit";
import { actionTrackingMiddleware } from '../SessionReplay/actionTrackingMiddleware';
import { taskSaveQueuedMiddleware } from './taskSaveQueued';

console.info('Setting up redux storage');

const sagaMiddleware = createSagaMiddleware();
const miscSagaMiddleware = createSagaMiddleware();

/*
 * Updates the configStore to use the new redux-toolkit callback.
 * This allows for the default middleware to be applied to all slices.
 *
 * Switching to new ReduxArrayMap requires using createEntitySlice helper.
 *
 * JCM: 2025-10-06, release 6.1.0
 */
const store = configureStore({
    reducer: root,
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
            actionCreatorCheck: false
        }).concat([taskSaveQueuedMiddleware, sagaMiddleware, miscSagaMiddleware, actionTrackingMiddleware]);
    }
});

// Start the saga middleware
sagaMiddleware.run(watchAll);
miscSagaMiddleware.run(watchMisc);

export default store;